<template>
  <div>buyCars</div>
</template>
<script>
export default {
  name: 'BuyCars',
}
</script>
